import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bb2fe14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col flex-nowrap h-full mx-auto w-auto min-w-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col flex-nowrap h-full mx-auto w-auto min-w-full"
}

import { computed, inject, ref, watch } from 'vue';
import { IncrediButton } from 'incredi-ui';
import { IKPageSize } from '@/types/injectionKeys';
import { NetworkStatus } from '@apollo/client/core';
import dashboardNoData from '@/views/dashboard/components/dashboard-no-data.vue';
import { useDashboardFilters } from '@/views/dashboard/components/dashboard-filter-bar/dashboard-filter.provider';
import { useDashboard, useFilteredDashboardMetadata } from '@/views/dashboard/dashboard.provider';
import { getNoDataForBuildCacheCharts } from '@/views/dashboard/dashboard.charts.utils';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useAgentsPageQuery } from '@/graphql/codegen/generated/graphql';
import HelperNeedRateChartController from './components/charts/helper-need-rate-chart/helper-need-rate-chart-controller.vue';
import BuildCacheCoreUsageChartController from './components/charts/build-cache-core-usage-chart/build-cache-core-usage-chart-controller.vue';
import BuildCacheCpuRunTimeAndSavedTimeChartController from './components/charts/build-cache-cpu-run-time-and-saved-time-chart/build-cache-cpu-run-time-and-saved-time-chart-controller.vue';
import DailyActiveHelperMachinesController from './components/charts/daily-active-helper-machines/daily-active-helper-machines-controller.vue';
import DailyActiveInitiatorMachinesController from './components/charts/daily-active-initiator-machines/daily-active-initiator-machines-controller.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardGridUtilization',
  setup(__props) {

const GQL_dashboardMetadataQuery = useFilteredDashboardMetadata({
  fetchPolicy: 'cache-and-network',
});
const coordinatorsService = inject(IKCoordinatorsService);

const GQL_AgentsPageQuery = useAgentsPageQuery(() => ({
  coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
}));

const size = inject(IKPageSize);
const dashboardFilters = useDashboardFilters();
const chartsKey = ref(0);

const dashboard = useDashboard();

if (dashboard.gql.gridUtilizationQuery.networkStatus.value === NetworkStatus.ready) dashboard.gql.gridUtilizationQuery.refetch();
else dashboard.gql.gridUtilizationQuery.load();

const dashboardGridUtilizationLayout = computed(() => {
  const hasBuildCacheLicense = GQL_AgentsPageQuery?.result?.value?.ibManagerEntities?.licenseMetadata?.hasBuildCache || false;
  const hasNoDataInBuildCacheCoreUsageChart = dashboard.metadata.value.gridUtilization.noData.buildCacheCoreUsageChart;
  const hasNoDataInBuildCacheCpuRunTimeAndSavedTimeChart = dashboard.metadata.value.gridUtilization.noData.buildCacheCpuRunTimeAndSavedTimeChart;
  const licenseNeededInBuildCacheCharts =
    getNoDataForBuildCacheCharts(hasBuildCacheLicense, hasNoDataInBuildCacheCoreUsageChart) === 'buildCacheLicenseeNeeded' &&
    getNoDataForBuildCacheCharts(hasBuildCacheLicense, hasNoDataInBuildCacheCpuRunTimeAndSavedTimeChart) === 'buildCacheLicenseeNeeded';
  return licenseNeededInBuildCacheCharts ? 'dashboard-charts-grid-container--build-cache-bottom' : 'dashboard-charts-grid-container--default';
});

watch(
  () => size?.value.width,
  newValue => {
    setTimeout(() => {
      if (newValue === size?.value.width) chartsKey.value += 1;
    }, 300);
  },
);

return (_ctx: any,_cache: any) => {
  return (_unref(GQL_dashboardMetadataQuery).networkStatus.value === _unref(NetworkStatus).ready && _unref(dashboard).gql.gridUtilizationQuery.networkStatus.value === _unref(NetworkStatus).ready)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (
        (Object.values(_unref(dashboard).metadata.value.gridUtilization.noData).every(s => s) && !_unref(dashboardFilters).isDirty.value) || !_unref(GQL_dashboardMetadataQuery).result.value?.dashboardMetadata?.hasWorkloads
      )
          ? (_openBlock(), _createBlock(dashboardNoData, {
              key: 0,
              icon: "no_data",
              "large-scale": "",
              title: _ctx.$t('dashboard.noData.title'),
              subtitle: _ctx.$t('dashboard.noData.subtitle')
            }, null, 8, ["title", "subtitle"]))
          : (Object.values(_unref(dashboard).metadata.value.gridUtilization.noData).every(s => s) && _unref(dashboardFilters).isDirty.value)
            ? (_openBlock(), _createBlock(dashboardNoData, {
                key: 1,
                icon: "no_result_found",
                "large-scale": "",
                title: _ctx.$t('dashboard.noData.noResultsFound')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IncrediButton), {
                    design: "primary-green",
                    class: "px-[12px] py-[8px] !rounded-[50px] text-[13px] font-gordita-medium mt-[24px]",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(dashboardFilters).clearFilters()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('dashboard.noData.clearFilters')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title"]))
            : (_openBlock(), _createElementBlock("div", {
                key: chartsKey.value,
                class: _normalizeClass(["dashboard-charts-grid-container--base mx-auto w-full max-w-[1624px]", _unref(dashboardGridUtilizationLayout)])
              }, [
                _createVNode(HelperNeedRateChartController, { class: "helper-need-rate-chart" }),
                _createVNode(BuildCacheCoreUsageChartController, { class: "cache-hours-consumption-chart" }),
                _createVNode(BuildCacheCpuRunTimeAndSavedTimeChartController, { class: "time-saved-by-cache-chart" }),
                _createVNode(DailyActiveHelperMachinesController, { class: "active-helper-machines-chart" }),
                _createVNode(DailyActiveInitiatorMachinesController, { class: "active-initiator-machines-chart" })
              ], 2))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(dashboardNoData, {
          icon: "no_data",
          "large-scale": "",
          title: _ctx.$t('dashboard.noData.title'),
          subtitle: _ctx.$t('dashboard.noData.subtitle')
        }, null, 8, ["title", "subtitle"])
      ]))
}
}

})